import { ANNOTATION_TARGETS } from 'constants';
import { COMPOSITION_PREFIX } from 'constants/annotations';

export const defined = subject => typeof subject !== 'undefined';
export const truthy = subject => defined(subject) && subject !== null;
export const fn = subject => truthy(subject) && typeof subject === 'function';
export const object = subject => truthy(subject) && typeof subject === 'object' && subject !== null;
export const string = subject => truthy(subject) && typeof subject === 'string';
export const array = subject => truthy(subject) && Array.isArray(subject);
export const number = subject => truthy(subject) && !isNaN(subject) && typeof subject === 'number';
export const compositionType = subject => string(subject) && subject.startsWith(COMPOSITION_PREFIX);
export const knownTarget = target => Object.values(ANNOTATION_TARGETS).includes(target);
export const adjacentTarget = subject => string(subject) && subject.startsWith('adjacent');
export const closeTo = (subject, comparison, margin) => subject <= comparison + margin && subject >= comparison - margin;
export const handled = (subject, method) => fn(subject[method]);
export const empty = subject => {
    if (array(subject)) {
        return subject.length === 0;
    } else if (object(subject)) {
        return Object.keys(subject).length === 0;
    }
};
export const equal = (a,b, args = {}) => {
    if (a === b) {
        return true;
    }

    if ( (string(a) && string(b)) || (number(a) && number(b)) ) {
        return a === b;
    } else if (array(a) && array(b)) {
        if (a.length === b.length) {
            if (args.sortArrays) {
                a = a.sort();
                b = b.sort();
            }

            return a.reduce((eq, aa, i) => eq && equal(aa,b[i],args), true);
        }

        return false;
    } else if (object(a) && object(b)) {
        const aKeys = Object.keys(a),
            bKeys = Object.keys(b);

        if (equal(aKeys,bKeys,args)) {
            return aKeys.reduce((eq,key,i) => {
                return eq && equal(a[key],b[key],args);
            }, true);
        }
    }

    return false;
};
export const validRegex = (item) => {
    try {
        new RegExp(item);
    } catch(e) {
        return false;
    }
    return true;
};
export const hls = subject => /\.m3u8$/.test(subject);
export const localized = (annotation = {}) => annotation.properties && annotation.properties.localized;
